import apiClient from '../plugins/axios';

/**
 * Base Service sınıfı - Tüm servisler için ortak metodları sağlar
 */
class BaseService {
  constructor(resource) {
    this.resource = resource;
  }

  /**
   * Tüm kayıtları getir
   * @param {Object} params - Query parametreleri
   * @returns {Promise}
   */
  async getAll(params = {}) {
    try {
      const response = await apiClient.get(this.resource, { params });
      // Swagger response wrapper yapısına göre data.data return et
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * ID'ye göre tek kayıt getir
   * @param {number|string} id - Kayıt ID'si
   * @returns {Promise}
   */
  async getById(id) {
    try {
      const response = await apiClient.get(`${this.resource}/${id}`);
      // Swagger response wrapper yapısına göre data.data return et
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Yeni kayıt oluştur
   * @param {Object} data - Oluşturulacak veri
   * @returns {Promise}
   */
  async create(data) {
    try {
      const response = await apiClient.post(this.resource, data);
      // Swagger response wrapper yapısına göre data.data return et
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Kayıt güncelle
   * @param {number|string} id - Güncellenecek kayıt ID'si
   * @param {Object} data - Güncellenecek veri
   * @returns {Promise}
   */
  async update(id, data) {
    try {
      const response = await apiClient.put(`${this.resource}/${id}`, data);
      // Swagger response wrapper yapısına göre data.data return et
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Kayıt sil
   * @param {number|string} id - Silinecek kayıt ID'si
   * @returns {Promise}
   */
  async delete(id) {
    try {
      const response = await apiClient.delete(`${this.resource}/${id}`);
      // Swagger response wrapper yapısına göre data.data return et
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Sayfalı veri getir
   * @param {Object} params - Sayfalama parametreleri
   * @returns {Promise}
   */
  async paginate(params = {}) {
    try {
      const response = await apiClient.get(`${this.resource}/paginate`, { params });
      // Swagger response wrapper yapısına göre data.data return et
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Arama işlemi
   * @param {string} query - Arama sorgusu
   * @param {Object} params - Ek parametreler
   * @returns {Promise}
   */
  async search(query, params = {}) {
    try {
      const response = await apiClient.get(`${this.resource}/search`, { params: { q: query, ...params } });
      // Swagger response wrapper yapısına göre data.data return et
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Hata yönetimi
   * @param {Error} error - Hata objesi
   * @returns {Error}
   */
  handleError(error) {
    // Hata zaten interceptor'da işlendi, sadece yeniden fırlat
    return error;
  }

  /**
   * Custom endpoint çağrısı
   * @param {string} endpoint - API endpoint'i
   * @param {string} method - HTTP metodu
   * @param {Object} data - Gönderilecek veri
   * @param {Object} params - Query parametreleri
   * @returns {Promise}
   */
  async customRequest(endpoint, method = 'GET', data = null, params = {}) {
    try {
      const config = {
        method: method.toLowerCase(),
        url: `${this.resource}/${endpoint}`,
        params,
      };

      if (data && ['post', 'put', 'patch'].includes(method.toLowerCase())) {
        config.data = data;
      }

      const response = await apiClient(config);
      // Swagger response wrapper yapısına göre data.data return et
      return response.data.data || response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default BaseService;
